// Firestore
const COLLECTIONS = {
  USERS: 'users',
  INGREDIENTS_TREES: 'ingredientsTrees', // Need to remove
  USER_STATISTICS: 'userStatistics',
  ALLERGENS: 'allergens',
  INGREDIENTS: 'ingredients',
  DECLARATIONS: 'declarations',
  FILTERS: 'filters',
  IMPACT_MEASUREMENTS: 'impactMeasurements',
  IMPACT_MEASUREMENTS_STATISTICS: 'impactMeasurementsStatistics',
  SEARCH_ITEMS: 'searchItems',
  PRODUCTS: 'products',
  PRODUCT_LOOKUP_GROUPS_V2: 'productLookupGroupsV2',
  PRODUCT_CHANGE_LOGS: 'productChangeLogs',
  QUESTIONS: 'questions',
  CATEGORIES: 'categories',
  SHOPPING_LISTS: 'shoppingList',
  CONTACT_US: 'contactUs',
  LANGUAGES: 'languages',
  LABELS: 'labels',
  DIETARY_NEEDS: 'dietaryNeeds',
  INGREDIENTS_ANALYSIS_TAGS: 'ingredientsAnalysisTags',
  NOTIFICATIONS: 'notifications',
  RECEIVERS: 'receivers',
  VERSIONS: 'versions',
  DEVICE_STATISTICS: 'deviceStatistics',
  VERSIONS_AVAILABILITY: 'versionsAvailability',
  BRANDS: 'brands',
  COUNTRIES: 'countries',
  MANUFACTURING_PLACES: 'manufacturingPlaces',
  PRODUCERS: 'producers',
  PRODUCT_STATISTICS: 'productStatistics',
  SETTINGS: 'settings',
  USER_SUBMITTED_PRODUCTS: 'userSubmittedProducts',
  DASHBOARD_PERFORMANCE_METRICS: 'dashboardPerformanceMetrics',
  APP_DAILY_STATISTICS: 'appDailyStatistics',
  APP_FEATURE_MONTHLY_STATISTICS: 'appFeatureMonthlyStatistics',
  APP_FEATURE_CURRENT_STATISTICS: 'appFeatureCurrentStatistics',
  APP_SUBSCRIPTIONS_STATISTICS: 'appSubscriptionsStatistics',
  SUBSCRIPTIONS: 'subscriptions',
  PREMIUM_CODES: 'premiumCodes',
  PREMIUM_GRANTS: 'premiumGrants'
}

// RDB
const PRODUCT_AMOUNT_RDB = 'statistic/productsAmount'
const INGREDIENTS_TREE_RDB = 'ingredientsTree'
const INGREDIENT_PRODUCTS_RDB = 'ingredientProducts'

export default COLLECTIONS
export { PRODUCT_AMOUNT_RDB, INGREDIENTS_TREE_RDB, INGREDIENT_PRODUCTS_RDB }
